import { ContentSourceType, PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { ENV } from '@environments/environment';

import { AbstractMultimediaItem } from './multimedia.abstract.model';

export abstract class Publication extends AbstractMultimediaItem {
  contentType!: PublicationContentType;

  constructor(multimediaItem: MSafeAny) {
    super(multimediaItem);
    this.contentSource = ContentSourceType.PUBLICATION;
    this.link = `${ENV.APP_UNIVERSAL_LINKS_URL}/p/${this.slug}`;
  }
}
